module.exports = __webpack_public_path__ + "static/img/cDR6.1d66fcae.png";